export const AVERAGE_SUPPORT_NPS = 'AVERAGE_SUPPORT_NPS';
export const AVERAGE_TICKET_RESOLUTION_TIME = 'AVERAGE_TICKET_RESOLUTION_TIME';
export const AVERAGE_TICKET_RESPONSE_TIME = 'AVERAGE_TICKET_RESPONSE_TIME';
export const CALLS_MADE = 'CALLS_MADE';
export const DEALS_CREATED = 'DEALS_CREATED';
export const MEETINGS_BOOKED = 'MEETINGS_BOOKED';
export const REVENUE = 'REVENUE';
export const TICKETS_CLOSED = 'TICKETS_CLOSED';